import React, { useState } from 'react';

import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import TopMenu from "../SharedComponents/TopMenu";
import Footer from "../SharedComponents/Footer";
import SvgIcon from "../SharedComponents/Icons";
import Benefits from "../SharedComponents/Benefits";
import FAQ from "../SharedComponents/FAQ";
import ContractsList from "./ContractsList";

import './index.sass';


const ContractsPage = ({ categories, faq, footer, regions, topMenu }) => {

  const [paymentType, setPaymentType] = useState('year');

  const regionsOptions = prepareOptionsForLocationSearch(regions);


  return (
    <div className="contracts-page">
      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <section className="contracts-page__top-info">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-7">
              <h1>Lej dine lokaler ud på Selskabslokaler.dk</h1>

              <ul>
                <li>
                  <SvgIcon name="check" width={24} height={24} />
                  Annoncering målrettet potentielle lejere i hele Danmark
                </li>
                <li>
                  <SvgIcon name="check" width={24} height={24} />
                  Markedsføring via Google og sociale medier
                </li>
                <li>
                  <SvgIcon name="check" width={24} height={24} />
                  40.000 besøgende om måneden
                </li>
                <li>
                  <SvgIcon name="check" width={24} height={24} />
                  Formidling af over 5.000 kontaktoplysninger om måneden
                </li>
              </ul>

              <p>Selskabslokaler.dk stiller et bredt udvalg af fest-, event og konference lokaler til rådighed. Derfor besøges hjemmesiden af tusindvis af potentielle kunder.</p>
              <p>Vi har over 40.000 månedlige besøgende, og mere end 1100 selskabslokaler i hele landet annonceres på hjemmesiden.</p>
            </div>

            <div className="col-lg-5 mobile-hidden">
              <SvgIcon name="map_dk" width={1000} height={1000} className="contracts-page__map-img"/>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <Benefits />
        </div>
      </section>

      <section className="contracts-page__contracts-section">
        <div className="container">
          <div className="contracts-page__contracts-section-header">
            <h2>Vælg din betalingsmodel</h2>
            <div className="contracts-page__pay-per-place">
              Betal pr. annonce
            </div>

            <div className="contracts-page__contracts-switcher">
              <div className={`contracts-page__contracts-switcher-button ${paymentType === 'month' ? 'active' : ''}`}
                   onClick={() => setPaymentType('month')}>
                Måned
              </div>
              <div className={`contracts-page__contracts-switcher-button ${paymentType === 'year' ? 'active' : ''}`}
                   onClick={() => setPaymentType('year')}>
                Årlig
              </div>
            </div>
          </div>

          <ContractsList paymentType={paymentType} />

          <div className="contracts-page__vat-info">
            <p>Alle priser er i DKK ekskl. moms</p>
            <p>Vi følger de gældende GDPR-retningslinjer.</p>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <FAQ data={faq} />
        </div>
      </section>

      <Footer { ...footer } />
    </div>
  )
}

export default ContractsPage;
